module.exports = __webpack_public_path__ + "static/media/logo-salesforce-landscape.7f7fbdaf.svg";